import { HeaderProps } from '../../Interfaces'
// import logo from '../../assets/svg/logo-no-background.svg'
import logo from '../../assets/logo-black-no-background.png'
import { usePublicSiteBranding } from '../../contexts/PublicSiteContext'

export default function Header({
    heading, paragraph="",
}: HeaderProps){
    const branding = usePublicSiteBranding()
    return(
        <div className="mb-10">
            <div className="flex justify-center">
                <img 
                    alt={branding.navbarLogoAlt}
                    className="p-6 h-36 max-w-xs object-contain"
                    src={branding.heroMarkLogoSrc ?? branding.markLogoSrc ?? logo}/>
            </div>
            <h2 className="mt-4 text-center text-gray-900">
                {heading}
            </h2>
            <p className="text-center text-sm text-gray-600 mt-5">
              {paragraph}  </p>
        </div>
    )
}